/* eslint-disable react/prop-types */
import React, { Component } from "react";
import styled from "styled-components";

import ds, { media } from "designsystem";
import Container from "blocks/Container/Container";
import Header1 from "elements/Header1";
import DescriptionText from "elements/DescriptionText";

const StyledContainer = styled(Container)`
  margin: ${ds.get("metrics.xl")} auto 0;
  padding: ${ds.get("metrics.s")};

  ${media.desktop`
    margin: ${ds.get("metrics.xxl")} auto ${ds.get("metrics.l")};
  `};
`;

const StyledHeader = styled(Header1)`
    font-size: ${ds.fs("l")};
    line-height: ${ds.get("type.lineHeight.l")};
    text-align: center;
    
    ${media.tablet`
      font-size: ${ds.fs("xl")};
      line-height: ${ds.get("type.lineHeight.xl")};
    `}
`;

const Description = styled(DescriptionText)`
    font-size: ${ds.fs("m")};
    line-height: ${ds.get("type.lineHeight.m")};
    text-align: center;

    ${media.tablet`
      font-size: ${ds.fs("l")};
      line-height: ${ds.get("type.lineHeight.l")};
    `}
`;

class TitleAndSubtitle extends Component {
  render() {
    const {
      data: {
        title,
        subtitle
      }
    } = this.props;

    return (
      <StyledContainer>
        <StyledHeader>
          {title}
        </StyledHeader>
        <Description>
          {subtitle}
        </Description>
      </StyledContainer>
    );
  }
}

export default TitleAndSubtitle;



// WEBPACK FOOTER //
// ./src/kentico-blocks/TitleAndSubtitle/index.jsx